/**
 * Single source of truth for affiliate bookmakers.
 * Add a bookmaker here, then enable placements (promoHot, recommended, etc.).
 */
export const BOOKMAKERS = [
  {
    id: '1xbet',
    name: '1xBet',
    logo: '/logos/1xbet.png',
    theme: 'blue',
    analytics: { click: 'click-1xbet', welcome: 'Click-welcome-bonus' },
    links: {
      affiliate: 'https://main-bet.com/1xmobi',
      android: 'https://main-bet.com/1xdownloadapp',
      ios: 'https://main-bet.com/1xdownloadapp',
      predictionsPath: '/1xbet-predictions',
    },
    promo: {
      code: 'BONUSMB',
      defaultOffer: { type: 'First Deposit', amount: '485 €' },
      recommended: {
        title: '150% Deposit Bonus',
        note: '*Only for new 1xBet customers',
      },
      welcome: {
        title: 'Welcome Bonus',
        headline: '130% welcome bonus on first deposit',
        ctaAmount: 'Up to €130',
      },
    },
    rating: 5,
    platforms: ['android', 'ios'],
    brandMark: {
      monogram: '1X',
      background: '#1A5490',
      color: '#FFFFFF',
    },
    placements: {
      promoHot: true,
      recommended: true,
      welcomeBanner: true,
      predictionsPage: true,
      matchOddsCta: true,
      matchCompact: true,
      accaSlip: true,
      matchTipCta: true,
      feedStrip: true,
      hubCompare: true,
    },
    sort: { promoHot: 1, recommended: 1, matchOddsCta: 1, matchCompact: 1, accaSlip: 1, matchTipCta: 1, feedStrip: 1, hubCompare: 1 },
  },
  {
    id: 'melbet',
    name: 'MelBet',
    logo: '/logos/melbet.png',
    theme: 'yellow',
    analytics: { click: 'click-melbet' },
    links: {
      affiliate: 'https://main-bet.com/melbet',
      android: 'https://main-bet.com/melbetdownloadapp',
      ios: 'https://main-bet.com/melbetdownloadapp',
      predictionsPath: '/melbet-predictions',
    },
    promo: {
      code: 'MAINBONUS',
      defaultOffer: { type: 'First Deposit/Free Bet', amount: '100 €' },
      recommended: {
        title: 'Free Bet + €100',
        note: '*Only for new MelBet customers',
      },
    },
    rating: 4,
    platforms: ['android', 'ios'],
    placements: {
      promoHot: true,
      recommended: true,
      welcomeBanner: false,
      predictionsPage: true,
      matchOddsCta: false,
      matchCompact: true,
      accaSlip: true,
      matchTipCta: false,
      feedStrip: true,
      hubCompare: true,
    },
    sort: { promoHot: 2, recommended: 2, matchCompact: 2, accaSlip: 2, feedStrip: 2, hubCompare: 2 },
  },
  {
    id: 'betwinner',
    name: 'BetWinner',
    logo: '/logos/betwinner.png',
    theme: 'green',
    analytics: { click: 'click-betwinner' },
    links: {
      affiliate: 'https://main-bet.com/betwinner',
      android: 'https://main-bet.com/betwinnerdownloadapp',
      ios: 'https://main-bet.com/betwinnerdownloadapp',
      predictionsPath: '/betwinner-predictions',
    },
    promo: {
      code: 'EUR100',
      defaultOffer: { type: 'First Deposit', amount: '100 €' },
      recommended: {
        title: '€100 Welcome Bonus',
        note: '*Only for new BW customers',
      },
    },
    rating: 4.5,
    platforms: ['android', 'ios'],
    placements: {
      promoHot: true,
      recommended: true,
      welcomeBanner: false,
      predictionsPage: true,
      matchOddsCta: false,
      matchCompact: true,
      accaSlip: true,
      matchTipCta: false,
      feedStrip: true,
      hubCompare: true,
    },
    sort: { promoHot: 3, recommended: 3, matchCompact: 3, accaSlip: 3, feedStrip: 3, hubCompare: 3 },
  },
  // Top-1 test: sort 0 puts 1win ahead of 1xBet in every placement, `bonusTop` on bonus lists.
  {
    id: '1win',
    name: '1win',
    logo: '/logos/1win.jpg',
    theme: 'blue',
    analytics: { click: 'click-1win' },
    links: {
      // Admin short link (Links tab), tracked by /api/go
      affiliate: 'https://main-bet.com/api/go/1win',
      android: null,
      ios: null,
      predictionsPath: null,
    },
    promo: {
      code: 'BONUSMAIN',
      defaultOffer: { type: 'Welcome package', amount: 'Up to 500%' },
      welcome: {
        title: 'Welcome package',
        headline: 'Up to 500% over four deposits with BONUSMAIN',
        ctaAmount: 'Up to 500%',
      },
    },
    rating: 4,
    bonusTop: true,
    platforms: [],
    placements: {
      promoHot: true,
      recommended: true,
      welcomeBanner: true,
      predictionsPage: false,
      matchOddsCta: true,
      matchCompact: true,
      accaSlip: true,
      matchTipCta: true,
      feedStrip: true,
      hubCompare: true,
    },
    sort: { promoHot: 0, recommended: 0, welcomeBanner: 0, matchOddsCta: 0, matchCompact: 0, accaSlip: 0, matchTipCta: 0, feedStrip: 0, hubCompare: 0 },
  },
  // Bonus pages and betting-site hubs only (owner decision 2026-10-31): no feed, match or acca placements.
  // `trial`: listed after the established partners until their clicks justify a higher place.
  {
    id: 'bcgame',
    name: 'BC.Game',
    logo: '/logos/bc-game.png',
    theme: 'green',
    analytics: { click: 'click-bcgame' },
    links: {
      affiliate: 'https://main-bet.com/api/go/bcgame',
      android: null,
      ios: null,
      predictionsPath: null,
    },
    promo: {
      code: '4d41hebza',
      defaultOffer: { type: 'Welcome bonus', amount: 'Deposit bonus' },
    },
    rating: 4,
    trial: true,
    platforms: [],
    placements: {
      hubCompare: true,
    },
    sort: { hubCompare: 5 },
  },
  // Compare-odds display only — no logos, promos, or site placements
  {
    id: 'pinnacle',
    name: 'Pinnacle',
    logo: null,
    oddsApiKey: 'pinnacle',
    region: 'eu',
    theme: 'gray',
    brandMark: {
      monogram: 'P',
      background: '#0F4C81',
      color: '#FFFFFF',
    },
    analytics: { click: 'click-pinnacle' },
    links: {
      affiliate: null,
      android: null,
      ios: null,
      predictionsPath: null,
    },
    promo: { code: null },
    rating: null,
    platforms: [],
    placements: {},
  },
  {
    id: 'betfair',
    name: 'Betfair',
    logo: null,
    oddsApiKey: 'betfair_ex_eu',
    region: 'eu',
    theme: 'gray',
    brandMark: {
      monogram: 'B',
      background: '#FFB80C',
      color: '#1A1A1A',
    },
    analytics: { click: 'click-betfair' },
    links: {
      affiliate: null,
      android: null,
      ios: null,
      predictionsPath: null,
    },
    promo: { code: null },
    rating: null,
    platforms: [],
    placements: {},
  },
  {
    id: 'polymarket',
    name: 'Polymarket',
    logo: null,
    oddsApiKey: 'polymarket',
    region: 'us_ex',
    theme: 'gray',
    brandMark: {
      monogram: 'PM',
      background: '#1652F0',
      color: '#FFFFFF',
    },
    analytics: { click: 'click-polymarket' },
    links: {
      affiliate: null,
      android: null,
      ios: null,
      predictionsPath: null,
    },
    promo: { code: null },
    rating: null,
    platforms: [],
    placements: {},
  },
  {
    id: 'kalshi',
    name: 'Kalshi',
    logo: null,
    oddsApiKey: 'kalshi',
    region: 'us_ex',
    theme: 'gray',
    brandMark: {
      monogram: 'K',
      background: '#00C389',
      color: '#FFFFFF',
    },
    analytics: { click: 'click-kalshi' },
    links: {
      affiliate: null,
      android: null,
      ios: null,
      predictionsPath: null,
    },
    promo: { code: null },
    rating: null,
    platforms: [],
    placements: {},
  },
  {
    id: 'db-bet',
    name: 'DoubleBet',
    logo: '/logos/db-bet.png',
    theme: 'yellow',
    analytics: { click: 'click-doublebet' },
    links: {
      // Tracker host refpaefd.top no longer resolves. Hop /db-bet → bonuses.
      affiliate: null,
      android: null,
      ios: null,
      predictionsPath: null,
    },
    promo: {
      code: 'EUR130',
      recommended: {
        title: '€130 Welcome Bonus',
        note: '*Only for new DB customers',
      },
    },
    rating: 3,
    platforms: [],
    placements: {
      promoHot: false,
      recommended: false,
      welcomeBanner: false,
      predictionsPage: false,
    },
    sort: {},
  },
];
